export default __webpack_public_path__ + "static/media/PAFI_Ringkasan Risalah RUPS_24 Juni 2024.f387017b.pdf";